import { useState } from "react";
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TreeView from '@mui/lab/TreeView';
import TreeItem from '@mui/lab/TreeItem';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';

export const OrgChartData = ({orgChartData}) => {
    const topLevel = orgChartData.value.filter(
        p => p.manager == null
        && p.id !== "1b9ef856-60f0-4076-84f1-953d2f4994f7"
        &&!(p.jobTitle != null && p.jobTitle.toString().includes("SystemAccount"))
    );

    const allIds = orgChartData.value.map(n => n.id);

    const [expanded, setExpanded] = useState(allIds);

    const handleToggle = (event, nodeIds) => {
        setExpanded(nodeIds);
    };

    const handleExpandClick = () => {
        setExpanded((oldExpanded) =>
            oldExpanded.length === 0 ? allIds : []
        );
    };

    const renderTree = (node) => {
        const children = orgChartData.value.filter(
            p => p.manager != null
              && p.manager.id === node.id
              && !(p.jobTitle != null
                  && p.jobTitle.toString().includes("SystemAccount"))
        );
        const sep = " \u2013 ";
        const phones = [...new Set([...node.businessPhones, node.mobilePhone].filter(num => num != null).map(num => num.replaceAll(" ", "-")))];
        const childNodes = children
                                .map(renderTree);
        const totalSize = childNodes
                                .map(cn => cn[1])
                                .reduce((a, b) => a + b, 1);
        const interleave = (arr, thing) => [].concat(...arr.map(n => [n, thing])).slice(0, -1)
        return [
            (
                <TreeItem
                    key={node.id}
                    nodeId={node.id}
                    sx={{
                      '& .MuiTreeItem-group': {
                        marginLeft: '50px',
                      },
                    }}
                    label={
                        <>
                            {
                                node.displayName
                            }
			    {
                                node.id ? <a href={"https://portal.azure.com/#view/Microsoft_AAD_UsersAndTenants/UserPropertiesEditor.ReactView/userId/" + node.id} target="_blank" rel="noopener noreferrer">✎</a> : null
			    }
                            {
                                node.jobTitle ? sep + node.jobTitle : ""
                            }
                            {
                                node.mail ? sep : null
                            }
                            {
                                node.mail ? <a href={"mailto:" + node.mail}>{node.mail}</a> : null
                            }
                            {
                                node.officeLocation ? sep + node.officeLocation : ""
                            }
                            {
                                phones.length > 0 ? ([
                                    sep,
                                    ...interleave(
                                        phones.map(num => <a key={num} href={"tel:" + num}>{num}</a>),
                                        <>,</>
                                    )
                                ]) : <></>
                            }
                            {
                                children.length > 0 ? (sep + "ORG(" + (totalSize - 1) + "):") : ""
                            }
                        </>
                    }
                >
                    {children.length > 0 ? childNodes
                                             .sort((a, b) => a[1] - b[1])
                                             .map(node => node[0]) : null}
                </TreeItem>
            ),
            totalSize
        ];
    }
    return (
        <Box sx={{ flexGrow:1, overflow: 'hidden', overflowY: 'auto' }}>
            <Box sx={{ mb: 1 }}>
                <Button onClick={handleExpandClick}>
                    {expanded.length === 0 ? 'Expand all' : 'Collapse all'}
                </Button>
            </Box>
            <TreeView
                aria-label="orgchart"
                className="orgChart"
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}
                defaultExpanded={topLevel.map(n => n.id)}
                expanded={expanded}
                onNodeToggle={handleToggle}
            >
                {topLevel.map(node => renderTree(node)[0])}
            </TreeView>
        </Box>
    );
};
